import { FC } from 'react';

import { Title, TitleProps } from '@mantine/core';

import cx from './SectionTitle.module.scss';

const SectionTitle: FC<
    { children: React.ReactNode; color?: TitleProps['c']; hugeTitle?: boolean; smallTitle?: boolean } & TitleProps
> = ({ children, color = '#000', hugeTitle, smallTitle, ...props }) => {
    return (
        <Title
            data-section-title
            order={2}
            c={color}
            className={`${cx.root} ${hugeTitle ? cx.hugeTitle : ''} ${smallTitle ? cx.smallTitle : ''}`}
            {...props}
        >
            {children}
        </Title>
    );
};

export { SectionTitle };
